module.exports = __webpack_public_path__ + "img/promo-card.383772aa.svg";